export default {
  planCategoryList: {
    method: "get",
    url: "/product-service/v1/internal/onboarding/insurance-plans/:product/insurances/:insuranceCode/presets",
  },
  getPresignUrl: {
    method: "post",
    url: "/product-service/v1/internal/onboarding/insurance-plans/presigned-create",
  },
  getPlanDetail: {
    method: "get",
    url: "/product-service/v1/internal/insurance-plans/:insuranceCategory/insurances/:insuranceCode/plans/:planCode",
  },
  createPlan: {
    method: "post",
    url: "/product-service/v1/internal/onboarding/insurance-plans/:productCode/insurances/:insuranceCode/plans",
  },
  updatePlan: {
    method: "put",
    url: "/product-service/v1/internal/onboarding/insurance-plans/:productCode/insurances/:insuranceCode/plans/:planCode",
  },
  deletePlan: {
    method: "delete",
    url: "/product-service/v1/internal/onboarding/insurance-plans/:productCode/insurances/:insuranceCode/plans/:planCode",
  },
  updatePlanStatus: {
    method: "post",
    url: "/product-service/v1/internal/onboarding/insurance-plans/:insuranceCategory/insurances/:insuranceCode/plans/:planCode/status",
  },
  insurerPlanList: {
    method: "get",
    url: "/product-service/v1/internal/onboarding/insurance-plans/:insuranceCode",
  },

  //insurance categories
  insuranceCategoriesList: {
    method: "get",
    url: "/product-service/v1/internal/insurance-categories",
  },
  createInsuranceCategories: {
    method: "post",
    url: "/product-service/v1/internal/insurance-categories",
  },
  deleteInsuranceCategories: {
    method: "delete",
    url: "/product-service/v1/internal/insurance-categories/:id",
  },

  //product categories
  productCategoriesList: {
    method: "get",
    url: "/product-service/v2/internal/product-categories",
  },
  createProductCategories: {
    method: "post",
    url: "/product-service/v2/internal/product-categories",
  },
  updateProductCategories: {
    method: "put",
    url: "/product-service/v2/internal/product-categories/:code",
  },
  deleteProductCategories: {
    method: "delete",
    url: "/product-service/v2/internal/product-categories/:code",
  },
  getProductCategories: {
    method: "get",
    url: "/product-service/v2/internal/product-categories/:code",
  },

  //Associate product categories
  getAssociateProductCategoriesList: {
    method: "get",
    url: "/product-service/v2/internal/product-categories/:code/associations",
  },
  createAssociateProductCategories: {
    method: "post",
    url: "/product-service/v2/internal/product-categories/:code/associations",
  },
  deleteAssociateProductCategories: {
    method: "delete",
    url: "/product-service/v2/internal/product-categories/:code/associations/:id",
  },
  updateAssociateProductCategories: {
    method: "put",
    url: "/product-service/v2/internal/product-categories/:code/associations/:id",
  },
  getAssociateProductCategoriesDetail: {
    method: "get",
    url: "/product-service/v2/internal/product-categories/:code/associations/:id",
  },

  //product management v2
  getPlanList: {
    method: "get",
    url: "/product-service/v2/internal/insurance-plans/basic-info",
  },
  createProductPlan: {
    method: "post",
    url: "/product-service/v2/internal/insurance-plans",
  },
  viewProductPlan: {
    method: "get",
    url: "/product-service/v2/internal/insurance-plans/:id",
  },
  updateProductPlan: {
    method: "put",
    url: "/product-service/v2/internal/insurance-plans/:id",
  },
  deleteProductPlan: {
    method: "delete",
    url: "/product-service/v2/internal/insurance-plans/:id",
  },

  //Associate product
  getBusinessUsecases: {
    method: "get",
    url: "/product-service/v2/internal/business-usecases",
  },
  getProductAssociationList: {
    method: "get",
    url: "/product-service/v2/internal/insurance-plans/:planCode/business-usecases",
  },
  upsertProductAssociation: {
    method: "post",
    url: "/product-service/v2/internal/insurance-plans/:planCode/business-usecases",
  },

  //Workflow Associate
  getWorkflowAssociationList: {
    method: "get",
    url: "/product-service/v2/internal/product-categories/:code/workflows",
  },
  createWorkflowAssociation: {
    method: "post",
    url: "/product-service/v2/internal/product-categories/:code/workflows",
  },
  deleteWorkflowAssociation: {
    method: "delete",
    url: "/product-service/v2/internal/product-categories/:code/workflows/:id",
  },
  updateWorkflowAssociation: {
    method: "put",
    url: "/product-service/v2/internal/product-categories/:code/workflows/:id",
  },
  getWorkflowAssociationDetail: {
    method: "get",
    url: "/product-service/v2/internal/product-categories/:code/workflows/:id",
  },
};
